import React from "react";
import "./TabLookingRadioButtons.css";

class TabLookingRadioButtons extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			activeTabIndex: props.initialTab || 0,
		};
		this.clicked = this.clicked.bind(this);
	}

	clicked(tabTitle, tabIndex) {
		this.setState({ activeTabIndex: tabIndex }, () => {
			this.props.switchedTab &&
				this.props.switchedTab(tabTitle, this.state.activeTabIndex);
		});
	}
	render() {
		return (
			<div
				className={
					"TabLookingRadioButtons noselect " +
					(this.props.className || "")
				}
				style={{
					display: "flex",
				}}
			>
				{this.props.columns.map((tabName, index) => {
					var isActiveTab;
					if (this.props.activeTabName) {
						//controlled component
						isActiveTab = this.props.activeTabName === tabName;
					} else {
						isActiveTab = this.state.activeTabIndex === index;
					}
					const hoverDescription =
						this.props.tabDescriptions &&
						this.props.tabDescriptions[tabName]
							? this.props.tabDescriptions[tabName]
							: null;

					const customTabName = this.props.customTabNames
						? this.props.customTabNames[tabName] || tabName
						: tabName;
					return (
						<div
							title={hoverDescription}
							className={
								"TabLookingRadioButtonsElement " +
								(isActiveTab ? "TLRB-Active" : "")
							}
							onClick={() => this.clicked(tabName, index)}
							key={"TLRBE-" + index}
						>
							{customTabName}
						</div>
					);
				})}
			</div>
		);
	}
}
const TabLookingRadioButtonsWithIcon = (props) => {
	return (
		<div style={{ display: "flex" }}>
			{props.iconComponent ? props.iconComponent : null}
			<TabLookingRadioButtons {...props} />
		</div>
	);
};
export default TabLookingRadioButtons;
export { TabLookingRadioButtonsWithIcon };
